export const HOME = 'HOME'
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'

export const CASE = 'CASE'

export const FETCH_DATA = 'FETCH_DATA'
export const FETCH_FORM = 'FETCH_FORM'
export const FETCH_SURVEY = 'FETCH_SURVEY'

export const UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION'
export const CLEAR_COMPLETED_NOTIFICATIONS = 'CLEAR_COMPLETED_NOTIFICATIONS'

export const DOWNLOAD_FILE = 'DOWNLOAD_FILE'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js